import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const QuestionIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 25.5C15.1557 25.5 17.2338 24.9525 19.0744 23.9272L24.3684 24.3684L23.9272 19.0744C24.9525 17.2338 25.5 15.1557 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5ZM18.1437 21.5776L18.4895 21.3698L21.6316 21.6316L21.3698 18.4895L21.5776 18.1437C22.5038 16.603 23 14.8394 23 13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13C3 18.5228 7.47715 23 13 23C14.8394 23 16.603 22.5038 18.1437 21.5776ZM13.0004 19.2479C13.691 19.2479 14.2508 18.6883 14.2508 17.9979C14.2508 17.3076 13.691 16.7479 13.0004 16.7479C12.3098 16.7479 11.75 17.3076 11.75 17.9979C11.75 18.6883 12.3098 19.2479 13.0004 19.2479ZM11.75 15.5H14.25V14.25C14.25 14.2531 14.2559 14.2465 14.2693 14.2318C14.3021 14.1957 14.3798 14.11 14.5256 13.9943C14.6508 13.895 14.6897 13.8693 15.006 13.6687C16.0826 12.9862 16.75 11.7995 16.75 10.5C16.75 8.42893 15.0711 6.75 13 6.75C10.9289 6.75 9.25 8.42893 9.25 10.5H11.75C11.75 9.80964 12.3096 9.25 13 9.25C13.6904 9.25 14.25 9.80964 14.25 10.5C14.25 10.9341 14.0282 11.3286 13.6675 11.5573C13.2627 11.8139 13.1955 11.8584 12.9719 12.0358C12.2284 12.6256 11.75 13.3284 11.75 14.25V15.5Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default QuestionIcon;
